export const DECIMAL_SEPARATOR = ",";

// Formatta un numero con la virgola come separatore decimale
export function formatNumber(num, decimals = 2) {
  if (num === null || num === undefined || isNaN(num)) return "";
  
  
  // Se num è una stringa numerica, convertila
  if (typeof num === "string") num = Number(num.replace(DECIMAL_SEPARATOR, "."));
  
  
  if (isNaN(num)) return "";
  return Number(num)
    .toFixed(decimals)
    .replace(".", DECIMAL_SEPARATOR);
}

// Parsing da stringa con virgola a numero JS
export function parseNumber(str) {
  if (typeof str !== "string") return Number(str);
  return Number(str.replace(DECIMAL_SEPARATOR, "."));
}